import type { RequestFailure } from '@ff-it/api';
import { messageFromFailure } from 'utilities';

export function formatError(err: unknown): string {
  const failure = err as RequestFailure<any> | undefined;
  const data = failure?.data;
  if (data == null) {
    return failure?.error?.message ?? '';
  }
  if (typeof data === 'string' || Array.isArray(data) || typeof data.detail === 'string') {
    return messageFromFailure(failure as RequestFailure<any>);
  }
  return Object.entries(data)
    .map(([field, value]) => {
      const text = Array.isArray(value) ? value.join(' ') : String(value);
      return field === 'non_field_errors' ? text : `${field}: ${text}`;
    })
    .join(' • ');
}
